export default (function mobileFiltersInit() {
    const mobileFilters = {
        buttonToggle() {
            $(document).on('click', '.js--show_filter', () => {
                $('#categories_block_left').removeClass('show');
                $('.sidebar .PM_ASBlockOutput').addClass('show');
                $('body').addClass('overlay_bg_dark');
            });
            $(document).on('click', '.js--hide_filter', () => {
                $('.sidebar .PM_ASBlockOutput').removeClass('show');
                $('body').removeClass('overlay_bg_dark');
            });
            $(document).on('click', '.js--show_category', () => {
                $('.sidebar .PM_ASBlockOutput').removeClass('show');
                $('#categories_block_left').addClass('show');
            });
            $(document).on('click', '.js--hide_category', () => {
                $('#categories_block_left').removeClass('show');
                $('body').removeClass('overlay_bg_dark');
            });
        },
        toggleGroup() {
            $(document).on('click', '.sidebar .PM_ASCriterionsGroupTitle', function () {
                $(this).toggleClass('active');
                $(this).closest('.PM_ASCriterionsGroup ').find('.PM_ASCriterionsGroupOuter').slideToggle(300);
            });
        },
    };
    $(document).ready(() => {
        mobileFilters.buttonToggle();
        mobileFilters.toggleGroup();
    });
}());
